export const typeImage = Object.freeze({
  GENERAL: 'GENERAL',
  DIC_REJECT_REASON: 'DIC_REJECT_REASON',
})

/**
 * @type {import(".").ConfigProps}
 */
export const config = {
  sidebar_drawer: true,
  mini_sidebar: false,
}
